import { AppProblemModel } from '@/services/api/AppProblemModel'
import { decodeBlobProblem } from '@/services/api/decodeBlobProblem'

/**
 * The single place an API failure becomes an application error.
 *
 * Every request through the Sanctum client passes its failure here, where it is
 * normalized into an AppProblemModel and then thrown. Callers therefore always
 * receive an AppProblemModel and never a raw transport error, without any of
 * them opting in.
 *
 * Presentation is deliberately not decided here. A request that fails is not
 * the same event as a page that cannot render: a component fetching something
 * optional gets a 404 it can absorb, while a page whose subject does not exist
 * needs the not-found screen. Only the caller knows which it is, so the global
 * error UI is requested per call through useApiRequest's globalErrorUi option.
 */
export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook('sanctum:error:response', async (context) => {
    throw AppProblemModel.normalize(await decodeBlobProblem(context), { context: 'api request' })
  })
})
